__turbopack_context__.v({
  "collapsedHiddenItem": "Breadcrumbs-module-scss-module__5XhPUa__collapsedHiddenItem",
  "collapsedList": "Breadcrumbs-module-scss-module__5XhPUa__collapsedList",
  "container": "Breadcrumbs-module-scss-module__5XhPUa__container",
  "currentItem": "Breadcrumbs-module-scss-module__5XhPUa__currentItem",
  "currentPage": "Breadcrumbs-module-scss-module__5XhPUa__currentPage",
  "ellipsisButton": "Breadcrumbs-module-scss-module__5XhPUa__ellipsisButton",
  "ellipsisItem": "Breadcrumbs-module-scss-module__5XhPUa__ellipsisItem",
  "lastItem": "Breadcrumbs-module-scss-module__5XhPUa__lastItem",
  "link": "Breadcrumbs-module-scss-module__5XhPUa__link",
  "list": "Breadcrumbs-module-scss-module__5XhPUa__list",
  "listItem": "Breadcrumbs-module-scss-module__5XhPUa__listItem",
  "parentItem": "Breadcrumbs-module-scss-module__5XhPUa__parentItem",
  "productNameItem": "Breadcrumbs-module-scss-module__5XhPUa__productNameItem",
});
